/* Netwerkloods — productpagina: galerij en variantkeuze via de Section Rendering API. */
(function () {
  'use strict';

  if (!customElements.get('media-gallery')) {
    customElements.define('media-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this._bound) return;
        this._bound = true;
        this.addEventListener('click', function (e) {
          var thumb = e.target.closest('[data-media-target]');
          if (thumb) this.setActive(thumb.getAttribute('data-media-target'));
        }.bind(this));
      }
      setActive(mediaId) {
        if (!mediaId) return;
        var slide = this.querySelector('.gallery__slide[data-media-id="' + mediaId + '"]');
        if (!slide) return;
        this.querySelectorAll('.gallery__slide').forEach(function (s) {
          var active = s === slide;
          s.classList.toggle('is-active', active);
          if (!active) {
            s.querySelectorAll('video').forEach(function (v) { v.pause(); });
          }
        });
        this.querySelectorAll('[data-media-target]').forEach(function (t) {
          t.setAttribute('aria-current', t.getAttribute('data-media-target') === String(mediaId) ? 'true' : 'false');
        });
      }
    });
  }

  if (!customElements.get('variant-picker')) {
    customElements.define('variant-picker', class extends HTMLElement {
      connectedCallback() {
        if (this._bound) return;
        this._bound = true;
        this.addEventListener('change', this.onChange.bind(this));
      }

      selectedValueIds() {
        var ids = [];
        this.querySelectorAll('fieldset.option-group, [data-option-select]').forEach(function (group) {
          if (group.matches('[data-option-select]')) {
            ids.push(group.value);
          } else {
            var checked = group.querySelector('input:checked');
            if (checked) ids.push(checked.value);
          }
        });
        return ids;
      }

      onChange(e) {
        var productInfo = this.closest('product-info');
        if (!productInfo) return;
        var focusId = e.target.id;
        var url = this.dataset.productUrl +
          '?option_values=' + this.selectedValueIds().join(',') +
          '&section_id=' + encodeURIComponent(this.dataset.sectionId);
        productInfo.classList.add('is-updating');
        productInfo.setAttribute('aria-busy', 'true');

        fetch(url)
          .then(function (r) {
            if (!r.ok) throw new Error(r.status);
            return r.text();
          })
          .then(function (html) {
            var doc = window.theme.parseHTML(html);
            var freshInfo = doc.querySelector('product-info');
            if (!freshInfo) throw new Error('missing');

            // Gecombineerde productlijsten: een andere productpagina laden.
            if (freshInfo.dataset.productUrl !== productInfo.dataset.productUrl) {
              window.location.href = freshInfo.dataset.productUrl;
              return;
            }

            var qtyInput = productInfo.querySelector('[data-product-region="buy"] input[name="quantity"]');
            var qty = qtyInput ? qtyInput.value : null;

            productInfo.querySelectorAll('[data-product-region]').forEach(function (region) {
              var name = region.getAttribute('data-product-region');
              var fresh = freshInfo.querySelector('[data-product-region="' + name + '"]');
              if (fresh) region.innerHTML = fresh.innerHTML;
            });

            if (window.theme.syncInCart) window.theme.syncInCart();

            var newQty = productInfo.querySelector('[data-product-region="buy"] input[name="quantity"]');
            if (newQty && qty) {
              var min = parseInt(newQty.min, 10) || 1;
              newQty.value = Math.max(min, parseInt(qty, 10) || min);
            }

            var variantJson = productInfo.querySelector('[data-selected-variant]');
            var variant = null;
            try { variant = variantJson ? JSON.parse(variantJson.textContent) : null; } catch (err) { variant = null; }

            if (variant && variant.id) {
              var params = new URLSearchParams(window.location.search);
              params.set('variant', variant.id);
              history.replaceState({}, '', window.location.pathname + '?' + params.toString());
              var gallery = productInfo.querySelector('media-gallery');
              if (gallery && variant.featured_media) gallery.setActive(variant.featured_media.id);
              document.querySelectorAll('[data-variant-sku]').forEach(function (el) {
                el.textContent = variant.sku || '';
              });
            }

            if (focusId) {
              var el = document.getElementById(focusId);
              if (el) el.focus();
            }
          })
          .catch(function () {
            // Bij een fout: terugvallen op een gewone paginalading met de gekozen optiewaarden.
            window.location.href = url.replace(/&section_id=[^&]*/, '');
          })
          .finally(function () {
            productInfo.classList.remove('is-updating');
            productInfo.removeAttribute('aria-busy');
          });
      }
    });
  }
})();
